import axios from "src/utils/axios";
import { createSlice } from "@reduxjs/toolkit";

// ----------------------------------------------------------------------

export const controllerName = "employeeRoles";
export const url = {
  create: `${controllerName}/Create`,
  update: `${controllerName}/Update`,
  delete: (id) => `${controllerName}/Delete/${id}`,
  read: (id) => `${controllerName}/Get/${id}`,
  readAll: `${controllerName}/Read`,
  readQuery: (page, pageSize, orderBy, orderDirection, searchTerm) =>
    `${controllerName}/ReadQuery?page=${page}&pageSize=${pageSize}&orderBy=${orderBy}&orderDirection=${orderDirection}&searchTerm=${searchTerm}`,
};

const initialState = {
  isLoading: false,
  error: false,
  employeeRoles: [],
  role: null,
};

// ----------------------------------------------------------------------

const slice = createSlice({
  name: "employeeRoles",
  initialState,
  reducers: {
    // LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    stopLoading(state) {
      state.isLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getAllEmployeeRolesSuccess(state, action) {
      state.employeeRoles = action.payload;
    },

    getEmployeeRoleSuccess(state, action) {
      state.role = state.employeeRoles.find(
        (role) => role.id == action.payload
      );
    },

    AddEmployeeRoleSuccess(state, action) {
      state.employeeRoles.push(action.payload);
    },

    updateEmployeeRoleSuccess(state, action) {
      state.employeeRoles = state.employeeRoles.map((role) =>
        role.id === action.payload.id ? action.payload : role
      );

      if (state.role !== null && state.role.id === action.payload.id) {
        state.role = action.payload;
      }
    },

    removeEmployeeRoleSuccess(state, action) {
      state.employeeRoles = state.employeeRoles.map((role) => {
        if (role.id == action.payload) {
          return {
            ...role,
            isActive: false,
            deleteDate: new Date(),
          };
        }

        return role;
      });

      if (state.role !== null && state.role.id === action.payload) {
        state.role = null;
      }
    },

    cleanEmployeeRoleSuccess(state) {
      if (state.role == null) return;

      state.role = null;
    },
  },
});

// ----------------------------------------------------------------------

// Reducer
export default slice.reducer;

// Actions
export const {
  getAllEmployeeRolesSuccess,
  getEmployeeRoleSuccess,
  AddEmployeeRoleSuccess,
  updateEmployeeRoleSuccess,
  removeEmployeeRoleSuccess,
  cleanEmployeeRole,
} = slice.actions;

// ----------------------------------------------------------------------

export function AddEmployeeRole(employee) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      dispatch(slice.actions.AddEmployeeRoleSuccess(employee));

      await axios.post(url.create, JSON.stringify(employee), {
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "Access-Control-Allow-Origin": "*",
        },
      });
      dispatch(slice.actions.stopLoading());
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function UpdateEmployeeRole(employee) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      dispatch(slice.actions.updateEmployeeRoleSuccess(employee));

      await axios.put(url.update, JSON.stringify(employee), {
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "Access-Control-Allow-Origin": "*",
        },
      });
      dispatch(slice.actions.stopLoading());
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function RemoveEmployeeRole(employeeID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      dispatch(slice.actions.removeEmployeeRoleSuccess(employeeID));

      await axios.delete(url.delete(employeeID), {
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "Access-Control-Allow-Origin": "*",
        },
      });
      dispatch(slice.actions.stopLoading());
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function GetEmployeeRoles() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      var response = await axios.get(url.readAll);

      dispatch(slice.actions.getAllEmployeeRolesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
